<div class="pull-right text-muted">
  <a href="#!/propriedade?sidebar=historyMapListing">
    <i class="icon-updated" aria-hidden="true"></i> Histórico
  </a>
</div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2 class="f-size-22">NOVO MAPA</h2>
</div>

<form name="mapaForm" ng-submit="mapa.save()" novalidate>

  <!-- gleba -->
  <div class="form-group" ng-class="{'has-error': mapaForm.gleba.$invalid}">
    <ui-select ng-model="mapa.newMap.gleba" theme="bootstrap" name="gleba" required>
      <ui-select-match placeholder="Talhão">{{$select.selected.descricao}}</ui-select-match>
      <ui-select-choices repeat="gleba in $root.currentPropriedade.glebas | filter: $select.search track by gleba.id">
        <span ng-bind-html="gleba.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>

  <!-- data -->
  <div class="form-group" ng-class="{'has-error': mapaForm.data.$invalid}">
    <div class="input-group">
      <input type="text" class="form-control" readonly datepicker-options="mapa.datePicker.options" placeholder="Data"
        uib-datepicker-popup="{{mapa.datePicker.format}}" ng-model="mapa.newMap.data"
        is-open="mapa.datePicker.open" show-button-bar="false"
        datepicker-append-to-body="true" name="data" required>
      <span class="input-group-btn">
        <button type="button" class="btn btn-default" ng-click="mapa.datePicker.open = !mapa.datePicker.open">
          <i class="glyphicon glyphicon-calendar"></i>
        </button>
      </span>
    </div>
  </div>

  <!-- tipo -->
  <div class="form-group" ng-class="{'has-error': mapaForm.tipo.$invalid}">
    <ui-select ng-model="mapa.newMap.tipo" theme="bootstrap" name="tipo" required>
      <ui-select-match placeholder="Tipo de mapa">{{$select.selected.descricao}}</ui-select-match>
      <ui-select-choices repeat="tipo in mapa.types | filter: $select.search track by tipo.id">
        <span ng-bind-html="tipo.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>

  <!-- descrição -->
  <div class="form-group" ng-class="{'has-error': mapaForm.descricao.$invalid}">
    <input type="text" name="descricao" required placeholder="Descrição" class="form-control" ng-model="mapa.newMap.descricao">
  </div>

  <!-- arquivo -->
  <div class="form-group" ng-class="{'has-error': mapaForm.file.$invalid}">
    <label for="file">Arquivo</label>
    <input file-input type="file" id="file" name="file" ng-model="mapa.tempFile" required
           accept="image/tiff,application/zip" ng-change="mapa.processFile()" ng-disabled="mapa.loadingShape">
    <span class="help-block">Selecione um arquivo GEOTiff (.tif, .tiff) ou um Shape File (.zip contendo os arquivos .shp, .shx, .dbf).</span>
  </div>
  <p class="text-cinza preloader text-center" ng-show="mapa.loadingShape">
    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Aguarde, processando Shape...
  </p>

  <!-- shape field (se for zip) -->
  <div class="form-group" ng-class="{'has-error': mapaForm.field.$invalid}" ng-show="mapa.shapeFields.length && !mapa.loadingShape">
    <ui-select ng-model="mapa.newMap.field" theme="bootstrap" name="field" ng-required="mapa.newMap.shape" ng-disabled="!mapa.shapeFields.length">
      <ui-select-match placeholder="Campo do Shape">{{$select.selected | capitalize}}</ui-select-match>
      <ui-select-choices repeat="field in mapa.shapeFields | filter: $select.search track by field">
        <span ng-bind-html="field | capitalize | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>

  <div class="btn-group btn-group-justified">
    <div class="btn-group">
      <button class="btn btn-primary padding-5" type="submit" ng-disabled="!mapa.canSave()">
        Salvar
        <span ng-show="mapa.loadingSave">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
      </button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn btn-default padding-5" ng-disabled="!mapa.canCancel()" ng-click="mapa.cancel()">
        Cancelar
      </button>
    </div>
  </div>
  <p class="text-cinza text-center" ng-show="mapa.loadingSave">
    Esta operação pode demorar. Por favor, aguarde nesta tela.
  </p>
</form>
